export default {
  ticket_id: "",
  price: "",
  promotion_id: "",
}
